import SimulacaoSquadsView from "../../components/gestaoOrcamentaria/SimulacaoSquadsView";

export default function SimulacaoSquads() {
  return <SimulacaoSquadsView />;
}
